<nav-bar [navBarItems]="periodosNavBar" [initialValue]="+periodosNavBar[0].value" [placeholder]="'Seleccione un año'"
         [navOnChange]="true"></nav-bar>
<ng-container *ngIf="materias.length > 0; else loading">
    <div>
        <ng-container *ngFor="let materia of materias">
            <materia-unidades [materia]="materia" [hijoID]="hijoID" [attr.id]="'mat-' + materia.id"></materia-unidades>
        </ng-container>
    </div>
</ng-container>
<ng-template #loading>
    <mat-progress-bar mode="query"></mat-progress-bar>
</ng-template>
